import { Check } from "lucide-react";
import { cn } from "@design-lab/shared/lib/tailwindcss";

export type ArtworkFeedbackThankYouProps = {
  className?: string;
};

export function ArtworkFeedbackThankYou({ className }: ArtworkFeedbackThankYouProps) {
  return (
    <div
      className={cn(
        "flex w-full items-center justify-center gap-1 text-center text-sm font-medium",
        className
      )}
    >
      Thank you for your feedback!
      <div className="ml-2 grid size-5 place-items-center rounded-full bg-blue-600">
        <Check className="text-background size-4" strokeWidth={2.5} />
      </div>
    </div>
  );
}
